import React from "react";

import PointTypes from "types/PointTypes";
import AreaTypes from "types/AreaTypes";

import MapCarMarker from "components/MapCarMarker";
import MapAvailableParkingLine from "components/MapAvailableParkingLine";

// @ts-ignore
import AvailableParkingUtils from "services/availableParking/utils";
import MapUtils from "services/map/utils";

type Props = {
  cars: { initialized: boolean; items: PointTypes[] | AreaTypes[] };
  options: {
    timestamp: number;
    zoom: number;
    radius: number;
    fill_color: { [key: string]: string };
    border_color: { [key: string]: string };
    border_weight: { [key: string]: number };
  };
};

function AvailableParkingLayers({ cars, options }: Props) {
  if (!cars?.initialized) {
    return [];
  }

  return cars?.items?.map((item, index) => {
    if (item.type === "area") {
      return (
        <MapAvailableParkingLine
          key={index}
          // @ts-ignore
          positions={MapUtils.getNormalizedLineCoordinates(
            // @ts-ignore
            item.start,
            // @ts-ignore
            item.end
          )}
          // @ts-ignore
          options={{ ...item, ...options }}
          zoom={options?.zoom}
        />
      );
    }

    if (AvailableParkingUtils.isSpot(item.type)) {
      return (
        <MapCarMarker
          key={index}
          center={MapUtils.getNormalizedCoordinates(item.position)}
          zoom={options?.zoom}
          // @ts-ignore
          options={{
            ...item,
            ...(options || {}),
          }}
        />
      );
    }

    return null;
  });
}

export default AvailableParkingLayers;
